import {
  Button,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Switch,
  Tooltip,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import {
  Post,
  DisplayMode,
  PostPersistantData,
  createNewPostFraction,
} from "./Post";
import { PlusIcon } from "lucide-react";
import { AliasType } from "../PostFlow";

export function PostEditingModal(props: {
  alias?: AliasType;
  initialState: undefined | PostPersistantData;
  onSave: (state: PostPersistantData) => void;
  onClose: () => void;
}) {
  const [state, setState] = useState<PostPersistantData>(
    props.initialState || {
      createTime: 0,
      fractions: [],
      hidden: false,
      id: undefined,
      lastEditedTime: undefined,
      pinTime: undefined,
      timing: { showStartEpoch: undefined, showEndEpoch: undefined },
      foldname: "",
    }
  );

  const [fractionIdInFocus, setFractionIdInFocus] = useState<
    string | undefined
  >(undefined);

  const [replaceAlias, setReplaceAlias] = useState(true);

  useEffect(() => {
    if (state.fractions.length === 1) {
      setFractionIdInFocus(state.fractions[0].id);
    }
  }, [state, setFractionIdInFocus, state.fractions]);

  return (
    <Modal
      closeOnOverlayClick={false}
      scrollBehavior={"inside"}
      isOpen={true}
      size={"full"}
      onClose={() => {
        props.onClose();
      }}
    >
      <ModalOverlay />
      <ModalContent background={"white"}>
        <ModalHeader>Skapa inlägg</ModalHeader>
        <ModalCloseButton />
        <ModalBody scrollBehavior={"auto"} margin={"20px"}
        >
          <div style={{ marginBottom: "60px" }}>
            <Post
              alias={replaceAlias ? props.alias ?? {} : {}}
              onSetTiming={function (): void {}}
              onCreateNewTiming={function (): void {}}
              state={state}
              mode={DisplayMode.EDIT}
              onStateUpdate={(newState: PostPersistantData) => {
                setState(newState);
              }}
              onPin={function (pin: boolean): void {}}
              onHide={function (hidden: boolean): void {}}
              onEdit={function (): void {}}
              onCopy={function (): void {}}
              onDelete={function (): void {}}
              fractionInFocus={fractionIdInFocus}
              setFractionInFocus={(id: string | undefined) =>
                setFractionIdInFocus(id)
              }
            />
          </div>
        </ModalBody>
        <ModalFooter borderRadius={"0px"} background={"blue.100"}>
          <Tooltip
            hidden={!props.alias}
            label={
              props.alias
                ? Object.entries(props.alias).map((entry) => (
                    <div key={`alias-${entry[0]}`}>
                      {`{{${entry[0]}}}`} - {entry[1]}
                    </div>
                  ))
                : "Inga alias"
            }
          >
            <HStack>
              <Switch
                marginRight={"10px"}
                colorScheme="green"
                isChecked={replaceAlias}
                onChange={() => {
                  setReplaceAlias((old) => !old);
                }}
              />{" "}
              <div>{replaceAlias ? "Ersätt alias" : "Visa alias"}</div>
            </HStack>
          </Tooltip>
          <Spacer />
          <Input
            margin={"20px"}
            marginTop={"0px"}
            marginBottom={"0px"}
            placeholder={"Dold text titel"}
            background={"white"}
            onChange={(e) => {
              setState((old) => ({ ...old, foldname: e.target.value }));
            }}
          />
          <HStack>
            <Button
              onClick={() => {
                setState((old) => {
                  const newFraction = createNewPostFraction(
                    "text",
                    old.fractions.length
                  );
                  setFractionIdInFocus(newFraction.id);
                  return {
                    ...old,
                    fractions: [...old.fractions, newFraction],
                  };
                });
              }}
              leftIcon={<PlusIcon />}
            >
              Text
            </Button>
            <Button
              onClick={() => {
                setState((old) => {
                  const newFraction = createNewPostFraction(
                    "image",
                    old.fractions.length
                  );
                  setFractionIdInFocus(newFraction.id);
                  return {
                    ...old,
                    fractions: [...old.fractions, newFraction],
                  };
                });
              }}
              leftIcon={<PlusIcon />}
            >
              Bild
            </Button>
            <Button
              onClick={() =>
                setState((old) => {
                  const newFraction = createNewPostFraction(
                    "links",
                    old.fractions.length
                  );
                  setFractionIdInFocus(newFraction.id);
                  return {
                    ...old,
                    fractions: [...old.fractions, newFraction],
                  };
                })
              }
              leftIcon={<PlusIcon />}
            >
              Länk
            </Button>
            <Button
              onClick={() =>
                setState((old) => {
                  const newFraction = createNewPostFraction(
                    "query",
                    old.fractions.length
                  );
                  setFractionIdInFocus(newFraction.id);
                  return {
                    ...old,
                    fractions: [...old.fractions, newFraction],
                  };
                })
              }
              leftIcon={<PlusIcon />}
            >
              Query
            </Button>
            <div style={{ width: "30px" }} />
            <Button
              onClick={() => {
                if (state !== undefined) {
                  props.onSave({ ...state, lastEditedTime: Date.now() });
                }
              }}
            >
              {" "}
              Spara{" "}
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
